module.exports = __webpack_public_path__ + "img/logo-intesa.96a5fc4a.png";